import { v4 as uuidv4 } from 'uuid';

export function newUuid(): string {
  return uuidv4();
}
